import { IProduct } from 'app/shared/model/product.model';
import { IDeal } from 'app/shared/model/deal.model';

export interface IDealProduct {
  id?: string;
  quantity?: number | null;
  keyword?: string | null;
  product?: IProduct | null;
  deal?: IDeal | null;
}

export const defaultValue: Readonly<IDealProduct> = {};
